import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  userProfile: {},
  isAuthenticated: false,
  isImpersonating: false,
  currentImpersonatedUser: null,
  isAdmin: null,
  memberId: '',
  userId: null,
  isAuthLoading: false,
  isTwoFactorRequired: false,
  authProviders: [],
  redirectUrl: '',
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
